module.exports = __webpack_public_path__ + "static/media/ki_omos_gyrizei.630466b3.jpg";